/* ═══════════════════════════════════════════════════════════════════════════
   🔨 DOE EEN BOD — het gedrag van de biedpagina (templates/product.bod.liquid)

   Drie dingen, en niet meer:
     1. de ondergrens ophalen bij de Worker, zodat een kansloos bod meteen zichtbaar
        is en de klant niet twee dagen voor niets wacht;
     2. het bedrag en de schuifbalk gelijk houden, met een eerlijk hulpregeltje
        ("dat is 72% van de adviesprijs" — een gemeten getal, geen aanmoediging);
     3. het bod versturen en de volglink teruggeven.

   BEWUST NIET: aftellende klokken, "iemand anders bood net", of een knop die pas na
   drie seconden werkt. De winkel jaagt niemand op — verzonnen schaarste is in de EU
   verboden en het is precies de belofte die later een supportticket wordt.

   VALT DE WORKER WEG, dan blijft de pagina bruikbaar: de ondergrens is dan onbekend,
   het formulier verstuurt gewoon, en de Worker weigert desnoods zelf. Eén kastje dat
   omvalt mag geen pagina slopen.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  var wortel = document.querySelector('.ewbod');
  if (!wortel) return;

  var handle = wortel.dataset.handle;
  // HET PRODUCT-ID, want `handle` is per markt VERTAALD ("vintaro-industrieller-barwagen-…"
  // op /de-de). De catalogus staat op de canonieke sleutel; het ID is overal hetzelfde en is
  // dus de betrouwbare ingang. Zonder dit meldde de pagina op elke niet-Nederlandse markt dat
  // er niet geboden kon worden.
  var pid = wortel.dataset.pid || '';
  var adviesprijs = parseFloat(wortel.dataset.prijs || '0');   // LOKALE prijs: 808 in Denemarken
  var worker = (wortel.dataset.worker || '').replace(/\/$/, '');
  if (!handle || !adviesprijs) return;

  /* ── DE MARKT WAAR DEZE BEZOEKER KIJKT ──────────────────────────────────────
     Alles op deze pagina staat in de munt van de bezoeker; alles wat over de lijn gaat
     staat in EURO. Dat is met opzet, en het is de duurste les van dit systeem.

     Dezelfde dranktrolley kost € 119,95 in België, € 54,95 in Duitsland en 808 kr in
     Denemarken. Tot 10 sep 2026 rekende deze pagina overal met "de helft van de prijs die
     er staat" als ondergrens. In Duitsland was dat € 25, terwijl kostprijs + Duitse btw op
     € 44,84 ligt — een uitnodiging om met verlies te verkopen. En in Denemarken kon iemand
     "600" invullen, wat wij dan als € 600 boekten in plaats van 600 kr (€ 78,69).

     Vandaar: het LAND komt uit Liquid (de markt, niet het bezorgland dat de klant kiest),
     de KOERS uit de winkel zelf — Shopify.currency = { active: "DKK", rate: "7.625" },
     precies de koers waarmee ook de prijzen op deze pagina getoond zijn.               */
  var land = (wortel.dataset.land || '').toUpperCase();
  var munt = (wortel.dataset.munt || 'EUR').toUpperCase();
  var koers = 1;
  try {
    var c = window.Shopify && window.Shopify.currency;
    if (c && c.active) munt = String(c.active).toUpperCase();
    if (c && parseFloat(c.rate) > 0) koers = parseFloat(c.rate);
  } catch (e) { /* dan blijft het EUR en koers 1 */ }
  if (munt === 'EUR') koers = 1;

  var naarEuro = function (lokaal) { return Math.round((lokaal / koers) * 100) / 100; };
  var naarLokaal = function (euro) { return euro * koers; };

  var form = document.getElementById('ewbod-form');
  var bedrag = document.getElementById('ewbod-bedrag');
  var schuif = document.getElementById('ewbod-schuif');
  var hint = document.getElementById('ewbod-hint');
  var foutvak = document.getElementById('ewbod-fout');
  var knop = document.getElementById('ewbod-verstuur');
  var klaar = document.getElementById('ewbod-klaar');
  var volglink = document.getElementById('ewbod-volglink');

  // Voorlopige grenzen tot de Worker antwoordt: half de adviesprijs. De echte grens
  // komt van de catalogus, want die hoort bij de bodemprijs die alleen de app kent.
  var min = Math.max(5, Math.round(adviesprijs * 0.5 / 5) * 5);
  var max = Math.max(min + 5, Math.round(adviesprijs) - 5);

  // Bedragen in de munt die de bezoeker ziet: "808,00 kr", niet "€ 808,00". Intl doet het
  // werk; kan de browser het niet, dan liever het getal met de code erachter dan een
  // euroteken bij kronen — dat laatste is niet lelijk maar onwaar.
  var geld = function (n) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl', { style: 'currency', currency: munt }).format(n);
    } catch (e) {
      return Number(n).toFixed(2).replace('.', ',') + ' ' + munt;
    }
  };
  var eur = function (n) { return '€ ' + Number(n).toFixed(2).replace('.', ','); };

  function grenzenZetten() {
    schuif.min = String(min);
    schuif.max = String(max);
    bedrag.min = String(min);
    if (!schuif.value || Number(schuif.value) < min) schuif.value = String(Math.round((min + max) / 2));
    if (!bedrag.value) bedrag.placeholder = String(Math.round((min + max) / 2));
  }

  // Eén hulpregel, drie standen. Het percentage is het enige getal dat we tonen en
  // het is een deling — niets meer.
  function hintZetten() {
    var b = parseFloat(String(bedrag.value).replace(',', '.'));
    hint.className = 'ewbod-hint';
    if (!b || b <= 0) { hint.textContent = 'Vul een bedrag in of sleep de balk.'; return; }
    var pct = Math.round(b / adviesprijs * 100);
    if (b < min) {
      hint.className = 'ewbod-hint laag';
      hint.textContent = 'Onder ' + geld(min) + ' nemen we een bod niet in behandeling.';
      return;
    }
    if (b >= adviesprijs) {
      hint.className = 'ewbod-hint';
      hint.textContent = 'Vanaf ' + geld(adviesprijs) + ' kun je hem gewoon kopen — dat gaat sneller.';
      return;
    }
    hint.className = 'ewbod-hint goed';
    // Rekent de bezoeker in een andere munt, dan zeggen we er meteen bij wat het in euro is:
    // het betaalverzoek komt in euro, en dat hoort geen verrassing te zijn aan de kassa.
    hint.textContent = 'Dat is ' + pct + '% van de adviesprijs.'
      + (munt === 'EUR' ? '' : ' Dat is ongeveer ' + eur(naarEuro(b)) + ' — het betaalverzoek volgt in euro.');
  }

  grenzenZetten();
  hintZetten();

  bedrag.addEventListener('input', function () {
    var b = parseFloat(String(bedrag.value).replace(',', '.'));
    if (b >= min && b <= max) schuif.value = String(Math.round(b));
    hintZetten();
  });
  schuif.addEventListener('input', function () {
    bedrag.value = schuif.value;
    hintZetten();
  });

  // De echte ondergrens ophalen bij de Worker.
  //
  // DRIE UITKOMSTEN, EN ZE ZIJN ALLEDRIE ANDERS:
  //   • het product staat open  → de echte ondergrens, formulier klaar;
  //   • het product staat NIET open (404) → formulier weg. Anders vult iemand een heel
  //     formulier in om daarna van de Worker te horen dat hier niet geboden kan worden;
  //     dat is de pagina laten liegen. Deze url is te raden voor élk product, dus dit
  //     geval is geen randgeval maar de normale toestand van 285 van de 286 producten.
  //   • de Worker antwoordt niet → laat staan wat er staat. Eén kastje dat omvalt mag
  //     geen pagina slopen; de Worker weigert desnoods zelf bij het versturen.
  function bodenUit(reden) {
    form.hidden = true;
    var mel = document.createElement('p');
    mel.className = 'ewbod-uit';
    mel.textContent = reden;
    form.parentNode.insertBefore(mel, form);
  }

  if (worker) {
    fetch(worker + '/catalogus/' + encodeURIComponent(handle) + '?markt=' + encodeURIComponent(land) + '&pid=' + encodeURIComponent(pid), { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 404) { bodenUit('Op dit product kun je op dit moment niet bieden. Je kunt het gewoon bestellen via de knop hieronder.'); return null; }
        return r.ok ? r.json() : null;
      })
      .then(function (j) {
        if (!j) return;
        // VIERDE UITKOMST sinds 10 sep 2026: het product staat wél open, maar niet in dít
        // land. Dat is geen storing — de picknicktafel van 110 kg staat bewust niet in
        // Italië, waar de verzending gratis is en een zending meer kost dan hij opbrengt.
        if (!j.ok) {
          bodenUit(j.reden === 'markt-dicht'
            ? 'Op dit product kun je in dit land niet bieden. Je kunt het gewoon bestellen via de knop hieronder.'
            : 'Bieden lukt hier even niet. Je kunt het product gewoon bestellen via de knop hieronder.');
          return;
        }
        // De grenzen komen in EURO binnen en worden hier omgerekend naar wat de bezoeker
        // ziet. NAAR BOVEN afronden bij de ondergrens: liever een paar kronen te streng dan
        // één kroon onder de kostprijs.
        if (j.min) min = munt === 'EUR' ? j.min : Math.ceil(naarLokaal(j.min));
        // De prijs op de pagina is de waarheid voor de bovengrens (die heeft de bezoeker
        // gezien). Wijkt de catalogus daar meer dan 5% van af, dan is er ergens een prijs
        // gewijzigd zonder dat de catalogus mee is; dan is de pagina de baas.
        if (j.adviesprijs) {
          var uitCat = munt === 'EUR' ? j.adviesprijs : naarLokaal(j.adviesprijs);
          var basis = Math.abs(uitCat - adviesprijs) / adviesprijs > 0.05 ? adviesprijs : uitCat;
          max = Math.max(min + 5, Math.round(basis) - 5);
        }
        grenzenZetten();
        hintZetten();
      })
      .catch(function () { /* de pagina blijft werken; de Worker weigert desnoods zelf */ });
  }

  // Verzenden of afhalen. Bij afhalen verdwijnt het adresblok: er wordt niets verzonden,
  // dus een postcode vragen zou een vraag zijn waar we niets mee doen. Bij een stuk van
  // 110 kg scheelt afhalen € 49,95 tot € 99,95 — dat is bij een bod van € 230 meer dan
  // de hele marge, dus het hoort een echte keuze te zijn en geen bijzin.
  var adresblok = document.getElementById('ewbod-adres');
  var leveruitleg = document.getElementById('ewbod-leveruitleg');
  function leveringGekozen() {
    var af = form.querySelector('[name="levering"]:checked').value === 'afhalen';
    if (adresblok) adresblok.hidden = af;
    if (leveruitleg) {
      leveruitleg.textContent = af
        ? 'Je haalt het zelf op in Lebbeke — daar rekenen we niets voor. We spreken een moment af zodra je bod rond is.'
        : 'De postcode hebben we nodig omdat de verzendkost ervan afhangt. Die komt bovenop je bod en staat in de mail met je betaallink.';
    }
  }
  [].forEach.call(form.querySelectorAll('[name="levering"]'), function (r) {
    r.addEventListener('change', leveringGekozen);
  });
  leveringGekozen();

  function fout(tekst) {
    foutvak.textContent = tekst;
    foutvak.hidden = false;
    knop.disabled = false;
    knop.textContent = 'Bod plaatsen';
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    foutvak.hidden = true;

    var b = parseFloat(String(bedrag.value).replace(',', '.'));
    if (!b || b <= 0) return fout('Vul eerst een bedrag in.');
    if (b < min) return fout('Onder ' + geld(min) + ' nemen we een bod niet in behandeling.');
    if (b >= adviesprijs) return fout('Vanaf ' + geld(adviesprijs) + ' kun je het product gewoon kopen.');
    var email = String(document.getElementById('ewbod-email').value || '').trim();
    if (!/^[^@\s]+@[^@\s.]+\.[a-z]{2,}$/i.test(email)) return fout('Vul een geldig e-mailadres in.');
    var afhalen = form.querySelector('[name="levering"]:checked').value === 'afhalen';
    var postcode = String(document.getElementById('ewbod-postcode').value || '').trim();
    if (!afhalen && !postcode) return fout('Vul je postcode in — de verzendkost hangt ervan af.');

    knop.disabled = true;
    knop.textContent = 'Versturen…';

    fetch(worker + '/bod', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        handle: handle,
        pid: pid,
        // In EURO over de lijn, met de koers erbij zodat de app kan tonen wat de klant zelf
        // op zijn scherm zag. Eén munt in de boekhouding, de eigen munt op het scherm.
        bedrag: munt === 'EUR' ? b : naarEuro(b),
        markt: land,
        valuta: munt,
        koers: koers,
        email: email,
        naam: document.getElementById('ewbod-naam').value || '',
        postcode: postcode,
        land: document.getElementById('ewbod-land').value || '',
        afhalen: afhalen,
        bericht: document.getElementById('ewbod-bericht').value || '',
        website: form.querySelector('[name="website"]').value || '',
      }),
    })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, j: j }; }); })
      .then(function (uit) {
        if (!uit.j || !uit.j.ok) {
          return fout((uit.j && uit.j.fout) || 'Het bod kwam niet door. Probeer het straks nog eens.');
        }
        form.hidden = true;
        klaar.hidden = false;
        if (uit.j.volglink) volglink.href = uit.j.volglink;
        else volglink.parentNode.hidden = true;
        klaar.scrollIntoView({ behavior: 'smooth', block: 'center' });
      })
      .catch(function () { fout('We konden je bod niet versturen. Staat je internet aan?'); });
  });
})();
